module.exports = {
    // 聊天伸缩变化事件
    CHATPANEL_SIZE_CHANGE: "CHATPANEL_SIZE_CHANGE"

    , SHOW_GOODS: "SHOW_GOODS"

    //战斗外buff返回更新事件
    , ADD_UPDATE_BUFF: "ADD_UPDATE_BUFF"

    , UPDATE_BUFF: "UPDATE_BUFF"

    , Partner_Red: 'Partner_Red'

    , CLOSE_ITEM_VIEW: "CLOSE_ITEM_VIEW"

    // 更新主城图标状态
    , UPDATE_FUNCTION_STATUS: "UPDATE_FUNCTION_STATUS"

    //头部资产更新事件
    , HEAD_UPDATE_WEALTH_EVENT: "HEAD_UPDATE_WEALTH_EVENT"

    //loading完进入主场景
    , LOADING_ENTER_SCENE: "LOADING_ENTER_SCENE"

    // , FunctionIconVo_UPDATE_SELF_EVENT: "FunctionIconVo_UPDATE_SELF_EVENT"
};